import React, { useState } from "react";
import LinkSlider from "../Components/LinkSlider";
// import OurSolutionBanner from "../Components/OurSolutionBanner";
import { motion } from "framer-motion";
import PeopleSafetyExecution from "../Components/PeopleSafetyExecution";
import Faq from "../Components/Faq";
import Contactus from "../Components/Contactus";
import { SubscribeSection } from "../Components/SubscribeSection";
import EsgSection from "../Components/EsgSection";
import { useLanguage } from "../Router/LanguageContext";
export default function EpcInfrastructure() {
  const [activeTab, setActiveTab] = useState("epc");
  const [videoLoaded, setVideoLoaded] = useState(false);
  const { dictionary } = useLanguage();

  const epcArray = {
    title: dictionary?.epcTitle,
    description: dictionary?.epcDesc,
    keycapabilities: dictionary?.keyCapabilities,
    arrayData: dictionary?.epcPoints || [],
  };

  const substationsArray = {
    title: dictionary?.substationsTitle,
    description: dictionary?.substationsDesc,
    keycapabilities: dictionary?.keyCapabilities,
    arrayData: dictionary?.substationsPoints || [],
  };

  const mediumlownetworksArray = {
    title: dictionary?.mediumLowTitle,
    description: dictionary?.mediumLowDesc,
    keycapabilities: dictionary?.keyCapabilities,
    arrayData: dictionary?.mediumLowPoints || [],
  };

  const energyefficiencyArray = {
    title: dictionary?.energyEfficiencyTitle,
    description: dictionary?.energyEfficiencyDesc,
    keycapabilities: dictionary?.keyCapabilities,
    arrayData: dictionary?.energyEfficiencyPoints || [],
  };

  return (
    <>
      {/* <OurSolutionBanner
        title="Energy & infrastructure"
        description="Delivering integrated EPC solutions that ensure reliable, efficient, and high-quality energy and infrastructure project execution."
        button="Request a consultation"
        bgImage="/assets/img/EPCBanner.png"
        redirect="/contact-us"
      /> */}
      <div className="heroSectionBgVideoWrapper">
        {!videoLoaded && (
          <img
            src="/assets/img/epcVideoBanner.png"
            alt=""
            className="bgVideo"
          />
        )}
        <video
          className={`bgVideo ${videoLoaded ? "showVideo" : "hideVideo"}`}
          autoPlay
          muted
          loop
          playsInline
          onLoadedData={() => setVideoLoaded(true)}
        >
          <source src="/assets/video/epc_service.mp4" type="video/mp4" />
        </video>
        <div className="heroSectionContentOuter">
          <div className="container-fluid maxContainerSection">
            <div className="row heroSectionContent">
              <div className="col-md-12 heroLeftSection aboutTextCenter">
                <h2 className="m-0 f-s-48">{dictionary?.energyInfraTitle}</h2>
                <p className="m-0 f-s-20">{dictionary?.energyInfraDesc}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <LinkSlider />

      <div className="integratedCleanSection">
        <div className="container-fluid maxContainerSection commonPadding">
          <div className="row">
            <div className="col-md-12 whowearehedaersection ourSolutionSectionHeader">
              <h2 className="m-0 f-s-48">{dictionary?.epcSectionTitle}</h2>
              <p className="m-0 f-s-20">
                {dictionary?.epcSectionDesc}
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 switchIntegratedOuter">
              <div className="switchIntegrated">
                <div
                  className={`switchIntegratedInner ${
                    activeTab === "epc" ? "switchIntegratedInnerActive" : ""
                  }`}
                  onClick={() => setActiveTab("epc")}
                >
                  <p className="m-0 f-s-20">
                    {dictionary?.epcTitle}
                  </p>
                </div>

                <div
                  className={`switchIntegratedInner ${
                    activeTab === "substations"
                      ? "switchIntegratedInnerActive"
                      : ""
                  }`}
                  onClick={() => setActiveTab("substations")}
                >
                  <p className="m-0 f-s-20">{dictionary?.substationsTitle}</p>
                </div>

                <div
                  className={`switchIntegratedInner ${
                    activeTab === "mediumlownetworks"
                      ? "switchIntegratedInnerActive"
                      : ""
                  }`}
                  onClick={() => setActiveTab("mediumlownetworks")}
                >
                  <p className="m-0 f-s-20">{dictionary?.mediumLowTitle}</p>
                </div>

                <div
                  className={`switchIntegratedInner ${
                    activeTab === "energyefficiency"
                      ? "switchIntegratedInnerActive"
                      : ""
                  }`}
                  onClick={() => setActiveTab("energyefficiency")}
                >
                  <p className="m-0 f-s-20">{dictionary?.energyEfficiencyTitle}</p>
                </div>
              </div>
            </div>
          </div>

          {activeTab === "epc" && (
            <div className="row tabSectionInner">
              <div className="col-md-6">
                <motion.img
                  src="/assets/img/CompleteelectricalNew.png"
                  className="img-fluid"
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.6, delay: 0.4 }}
                  viewport={{ once: true }}
                />
              </div>
              <div className="col-md-6 tabSectionInnerRight">
                <motion.h3
                  className="mission-title m-0 f-s-48"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                >
                  {epcArray.title}
                </motion.h3>
                <motion.p
                  className="mission-text m-0 f-s-20"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  viewport={{ once: true }}
                >
                  {epcArray?.description}
                </motion.p>

                <motion.h6
                  className="f-s-20 m-0 keyCapabilities"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                >
                  {epcArray.keycapabilities}
                </motion.h6>
                <img src="/assets/img/Line.svg" alt="" className="img-fluid" />
                {epcArray?.arrayData?.map((item, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.4 + i * 0.15 }}
                    viewport={{ once: true }}
                  >
                    <div className="energysectionpoints f-s-18">
                      <img src="/assets/img/tickIcon.svg" alt="" /> {item}
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          )}

          {activeTab === "substations" && (
            <div className="row tabSectionInner">
              <div className="col-md-6">
                <div className="mission-image-wrapper">
                  <motion.img
                    src="/assets/img/SubstationsNew.png"
                    className="img-fluid"
                    initial={{ opacity: 0, scale: 0.8 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.6, delay: 0.4 }}
                    viewport={{ once: true }}
                  />
                </div>
              </div>
              <div className="col-md-6 tabSectionInnerRight">
                <motion.h3
                  className="mission-title m-0 f-s-48"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                >
                  {substationsArray.title}
                </motion.h3>
                <motion.p
                  className="mission-text m-0 f-s-20"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  viewport={{ once: true }}
                >
                  {substationsArray?.description}
                </motion.p>

                <motion.h6
                  className="f-s-20 m-0 keyCapabilities"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                >
                  {substationsArray.keycapabilities}
                </motion.h6>
                <img src="/assets/img/Line.svg" alt="" className="img-fluid" />
                {substationsArray?.arrayData?.map((item, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.4 + i * 0.15 }}
                    viewport={{ once: true }}
                  >
                    <div className="energysectionpoints f-s-18">
                      <img src="/assets/img/tickIcon.svg" alt="" /> {item}
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          )}

          {activeTab === "mediumlownetworks" && (
            <div className="row tabSectionInner">
              <div className="col-md-6 col-values-img">
                <motion.img
                  className="value-img-main"
                  src="/assets/img/voltagenetworksMain.png"
                  alt=""
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8 }}
                  viewport={{ once: true }}
                />
                {/* <motion.img
                  className="value-img-right box-img-common-style EnergyefficiencyHeadImage"
                  src="/assets/img/voltagenetworksSub.png"
                  alt=""
                  initial={{ opacity: 0, scale: 0.85 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  whileHover={{
                    scale: 1.03,
                    transition: { duration: 0.25, ease: "easeIn" },
                  }}
                  transition={{ duration: 1, ease: "easeInOut" }}
                  viewport={{ once: true }}
                /> */}
              </div>

              <div className="col-md-6 tabSectionInnerRight">
                <motion.h3
                  className="mission-title m-0 f-s-48"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                >
                  {mediumlownetworksArray.title}
                </motion.h3>
                <motion.p
                  className="mission-text m-0 f-s-20"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  viewport={{ once: true }}
                >
                  {mediumlownetworksArray?.description}
                </motion.p>

                <motion.h6
                  className="f-s-20 m-0 keyCapabilities"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                >
                  {mediumlownetworksArray.keycapabilities}
                </motion.h6>
                <img src="/assets/img/Line.svg" alt="" className="img-fluid" />
                {mediumlownetworksArray?.arrayData?.map((item, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.4 + i * 0.15 }}
                    viewport={{ once: true }}
                  >
                    <div className="energysectionpoints f-s-18">
                      <img src="/assets/img/tickIcon.svg" alt="" /> {item}
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          )}

          {activeTab === "energyefficiency" && (
            <div className="row tabSectionInner">
              <div className="col-md-6">
                <motion.img
                  src="/assets/img/EnergyefficiencyEPC.png"
                  className="img-fluid"
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.6, delay: 0.4 }}
                  viewport={{ once: true }}
                />
              </div>
              <div className="col-md-6 tabSectionInnerRight imgTabSection">
                <div>
                  <motion.h3
                    className="mission-title m-0 f-s-48"
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                  >
                    {energyefficiencyArray.title}
                  </motion.h3>
                  <motion.p
                    className="mission-text m-0 f-s-20"
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    viewport={{ once: true }}
                  >
                    {energyefficiencyArray?.description}
                  </motion.p>

                  <motion.h6
                    className="f-s-20 m-0 keyCapabilities"
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                  >
                    {energyefficiencyArray.keycapabilities}
                  </motion.h6>
                  <img
                    src="/assets/img/Line.svg"
                    alt=""
                    className="img-fluid"
                  />
                  {energyefficiencyArray?.arrayData?.map((item, i) => (
                    <motion.div
                      key={i}
                      initial={{ opacity: 0, x: 30 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.4, delay: 0.4 + i * 0.15 }}
                      viewport={{ once: true }}
                    >
                      <div className="energysectionpoints f-s-18">
                        <img src="/assets/img/tickIcon.svg" alt="" /> {item}
                      </div>
                    </motion.div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <EsgSection />

      <div className="section-main-contact-us">
        <div className="container-fluid maxContainerSection commonPadding pb-0">
          <div className="row">
            <div className="col-md-12 whowearehedaersection ourSolutionSectionHeader">
              <h2 className="m-0 f-s-48">{dictionary?.getInTouchTitle}</h2>
              <p className="m-0 f-s-20 ">
                {dictionary?.getInTouchDesc}
              </p>
            </div>
          </div>
          <Contactus />
        </div>
      </div>
      <PeopleSafetyExecution />

      <Faq />
      <SubscribeSection />
    </>
  );
}
